import styled from "styled-components";

export const StyledFrame = styled.div`
  display: flex;
  height: 100vh;
  width: 100%;
`;
